import { ReactComponent as LineChartIcon } from './chart.svg';

export default LineChartIcon;
